import styled from 'styled-components'

export const DashboardAlarmDetailsContainer = styled.div`
    flex: 1;
    width: 100%;
    height: calc(100% + 10px);

    border-radius: 0px 4px 0px 0px;
`
